import AlbumCover from './AlbumCover';
import SeekBar from './controls/SeekBar';
import VolumeControl from './controls/VolumeControl';
import LikeButton from './controls/LikeButton';
import { PlayIcon, PauseIcon, PrevIcon, NextIcon, ChevronDownIcon } from './icons';
import { usePlayer } from '../player/PlayerContext';

export default function MobileNowPlayingSheet() {
  const {
    currentAlbum, isPlaying, togglePlay, next, prev,
    npsOpen, closeNowPlaying,
  } = usePlayer();

  if (!currentAlbum) return null;

  const style = {
    '--album-accent': currentAlbum.accent,
  };

  return (
    <div className={`nps ${npsOpen ? 'open' : ''}`} style={style} aria-hidden={!npsOpen}>
      <div className="nps-topbar">
        <button className="icon-btn" onClick={closeNowPlaying} aria-label="Close now playing">
          <ChevronDownIcon />
        </button>
        <div className="nps-eyebrow">Now Playing</div>
        <LikeButton albumId={currentAlbum.id} size={22} />
      </div>

      <div className="nps-cover-wrap">
        <AlbumCover album={currentAlbum} className="nps-cover" />
      </div>

      <div>
        <div className="nps-title">{currentAlbum.title}</div>
        <div className="nps-artist">{currentAlbum.artist}</div>
      </div>

      <SeekBar compact />

      <div className="nps-controls-row">
        <button className="icon-btn" onClick={prev} aria-label="Previous"><PrevIcon size={28} /></button>
        <button className="play-toggle" onClick={togglePlay} aria-label={isPlaying ? 'Pause' : 'Play'}>
          {isPlaying ? <PauseIcon size={32} /> : <PlayIcon size={32} />}
        </button>
        <button className="icon-btn" onClick={next} aria-label="Next"><NextIcon size={28} /></button>
      </div>

      <div className="nps-volume">
        <VolumeControl className="nps" />
      </div>
    </div>
  );
}
